import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, isAlphanumeric, resolveOrientation, formatMoney, callGameServerApi } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import { AiFillDollarCircle, AiOutlineSetting } from 'react-icons/ai';
import { MdOutlinePriceChange, MdOutlinePhonelinkRing, MdOutlineMarkEmailUnread, MdOutlineLogout } from 'react-icons/md';
import { RiLockPasswordLine } from 'react-icons/ri';
import { FaAward } from 'react-icons/fa';


export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";

  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ oldPassword, setOldPassword ] = useState('');
  const [ newPassword, setNewPassword ] = useState('');
  const [ confirmPassword, setConfirmPassword ] = useState('');



  const init = async () => {
    appContext.changeOrientation(requiredOrientation);
    setReady(true);
  }

  const changePassword = async () => {
    if(!loading) {
      if(oldPassword.trim().length > 0) {
        if(newPassword.trim().length > 0) {
          if(confirmPassword === confirmPassword) {
            setLoading(true);
            await callGameServerApi('change-password', { oldPassword, newPassword }).then(response => {
              setLoading(false);
              if(response.status === 1) {
                appContext.tellMessage('Password change was successful')
              } else {
                appContext.tellError(response.msg);
              }
            })
          } else {
            appContext.tellError('Please confirm your password correctly');
          }
        } else {
          appContext.tellError('Invalid new password');
        }
      } else {
        appContext.tellError('Invalid old password');
      }
    }
  }

  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();
    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  if(ready) {
    return (
      <>
        <TopBar title="Change Password"/>
        <div className="FullPane"  data-support-top-bar={true}>
          <div className="container">
            <div className="row">

              <div className="col-md-6 col-sm-12" style={{ marginTop: "30px", paddingBottom: "30px" }}>
                <div className='form-group'>
                  <label>Old Password</label>
                  <input type="password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value.trim())} maxLength={30} className='form-control'/>
                </div>

                <div className='form-group'>
                  <label>New Password</label>
                  <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value.trim())} maxLength={30} className='form-control'/>
                </div>

                <div className='form-group'>
                  <label>Confirm New Password</label>
                  <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value.trim())} maxLength={30} className='form-control'/>
                </div>

                <div className='form-group text-end'>
                  <button onClick={changePassword} className="btn bg-redish text-dark">Change Password</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </>
    )
  } else {
    return (
      <div className="FullPane">
        {getInlineLoader()}
      </div>
    )
  }
}
